// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { UserStatus } from "../../user/v1/user";
import { PolicyRef } from "../../policy/v1/policy";
import { AppManagedStateBindingRef } from "./app_managed";
import { User } from "../../user/v1/user";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * Set the icon for an app.
 * Endpoint Requirements:
 * - The icon must be a valid PNG, JPEG or WebP image.
 * - The icon must be less than 1mb in size.
 * - The icon must be a square image.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppIconRequest
 */
export interface SetAppIconRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: bytes data = 2
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.app.v1.SetAppIconResponse
 */
export interface SetAppIconResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.UpliftAppUsersRequest
 */
export interface UpliftAppUsersRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.UpliftAppUsersResponse
 */
export interface UpliftAppUsersResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppExpandMask
 */
export interface AppExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppView
 */
export interface AppView {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: string parent_app_path = 2
     */
    parentAppPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppRef
 */
export interface AppRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * The App object provides all of the details for an app, as well as some configuration.
 *
 * @generated from protobuf message c1.api.app.v1.App
 */
export interface App {
    /**
     * The ID of the app.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the App was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the App was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the App was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4
     */
    deletedAt?: Timestamp;
    /**
     * The app's display name.
     *
     * @generated from protobuf field: string display_name = 5
     */
    displayName: string;
    /**
     * The app's description.
     *
     * @generated from protobuf field: string description = 6
     */
    description: string;
    /**
     * The ID of the Grant Policy associated with this App.
     *
     * @generated from protobuf field: string grant_policy_id = 7
     */
    grantPolicyId: string;
    /**
     * The ID of the Revoke Policy associated with this App.
     *
     * @generated from protobuf field: string revoke_policy_id = 8
     */
    revokePolicyId: string;
    /**
     * The URL of a logo to display for the app.
     *
     * @generated from protobuf field: string logo_uri = 9
     */
    logoUri: string;
    /**
     * The ID of the app that created this app, if any.
     *
     * @generated from protobuf field: string parent_app_id = 10
     */
    parentAppId: string;
    /**
     * The ID of the Certify Policy associated with this App.
     *
     * @generated from protobuf field: string certify_policy_id = 11
     */
    certifyPolicyId: string;
    /**
     * The ID of the Account named by AccountName.
     *
     * @generated from protobuf field: string app_account_id = 12
     */
    appAccountId: string;
    /**
     * The AccountName of the app. For example, AWS is AccountID, Github is Org Name, and Okta is Okta Subdomain.
     *
     * @generated from protobuf field: string app_account_name = 13
     */
    appAccountName: string;
    /**
     * The URL of an icon to display for the app.
     *
     * @generated from protobuf field: string icon_url = 14
     */
    iconUrl: string;
    /**
     * The cost of an app per-seat, so that total cost can be calculated by the grant count.
     *
     * @generated from protobuf field: int32 monthly_cost_usd = 15
     */
    monthlyCostUsd: number;
    /**
     * A list of fields that have been edited by a user to prevent a connector from overwriting their data.
     *
     * @generated from protobuf field: google.protobuf.FieldMask field_mask = 16
     */
    fieldMask?: FieldMask;
    /**
     * The number of users with grants to this app.
     *
     * @generated from protobuf field: int64 user_count = 17
     */
    userCount: number;
    /**
     * Specifies if the app is a directory.
     *
     * @generated from protobuf field: bool is_directory = 18
     */
    isDirectory: boolean;
    /**
     * The owners of the app.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.User app_owners = 19
     */
    appOwners: User[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserIdentityMatching identity_matching = 20
     */
    identityMatching: AppUserIdentityMatching;
    /**
     * @generated from protobuf field: bool is_manually_managed = 22
     */
    isManuallyManaged: boolean;
    /**
     * @generated from protobuf field: bool strict_access_entitlement_provisioning = 23
     */
    strictAccessEntitlementProvisioning: boolean;
    /**
     * @generated from protobuf field: uint32 connector_version = 24
     */
    connectorVersion: number;
    /**
     * The ID for the default request catalog for this app.
     *
     * @generated from protobuf field: string default_request_catalog_id = 25
     */
    defaultRequestCatalogId: string;
    /**
     * If you add instructions here, they will be shown to users in the access request form when requesting access for this app.
     *
     * @generated from protobuf field: string instructions = 26
     */
    instructions: string;
    /**
     * When enabled, resource ownership is sourced from the connector.
     *
     * @generated from protobuf field: bool enable_connector_sourced_ownership = 27
     */
    enableConnectorSourcedOwnership: boolean;
}
/**
 * The CreateAppRequest message is used to create a new app.
 *
 * @generated from protobuf message c1.api.app.v1.CreateAppRequest
 */
export interface CreateAppRequest {
    /**
     * Creates the app with this display name.
     *
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * Creates the app with this description.
     *
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * Creates the app with this array of owners.
     *
     * @generated from protobuf field: repeated string owners = 4
     */
    owners: string[];
    /**
     * Creates the app with this grant policy.
     *
     * @generated from protobuf field: string grant_policy_id = 5
     */
    grantPolicyId: string;
    /**
     * Creates the app with this revoke policy.
     *
     * @generated from protobuf field: string revoke_policy_id = 6
     */
    revokePolicyId: string;
    /**
     * Creates the app with this certify policy.
     *
     * @generated from protobuf field: string certify_policy_id = 7
     */
    certifyPolicyId: string;
    /**
     * Creates the app with this monthly cost per seat.
     *
     * @generated from protobuf field: int32 monthly_cost_usd = 8
     */
    monthlyCostUsd: number;
    /**
     * This flag enforces a provisioning mode where the access entitlement is always included in the provisioning flow, if the app user doesn't exist
     *
     * @generated from protobuf field: bool strict_access_entitlement_provisioning = 9
     */
    strictAccessEntitlementProvisioning: boolean;
    /**
     * Define the app user identity matching strategy for this app.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserIdentityMatching identity_matching = 10
     */
    identityMatching: AppUserIdentityMatching;
    /**
     * Instructions shown to users in the access request form when requesting access for this app.
     *
     * @generated from protobuf field: string instructions = 11
     */
    instructions: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppWithConnectorRequest
 */
export interface CreateAppWithConnectorRequest {
    /**
     * The app displayName.
     *
     * @generated from protobuf field: string app_display_name = 1
     */
    appDisplayName: string;
    /**
     * The app description.
     *
     * @generated from protobuf field: string app_description = 2
     */
    appDescription: string;
    /**
     * The catalogId describes which catalog entry this connector is an instance of. For example, every Okta connector will have the same catalogId indicating it is an Okta connector.
     *
     * @generated from protobuf field: string catalog_id = 3
     */
    catalogId: string;
    /**
     * The userIds of the app owners.
     *
     * @generated from protobuf field: repeated string app_owners_ids = 4
     */
    appOwnersIds: string[];
    /**
     * The userIds of the connector owners. If let blank, the app owners will be used as the connector owners.
     *
     * @generated from protobuf field: repeated string connector_owners_ids = 5
     */
    connectorOwnersIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppWithUnmanagedRequest
 */
export interface CreateAppWithUnmanagedRequest {
    /**
     * The app displayName.
     *
     * @generated from protobuf field: string app_display_name = 1
     */
    appDisplayName: string;
    /**
     * The app description.
     *
     * @generated from protobuf field: string app_description = 2
     */
    appDescription: string;
    /**
     * The catalogId describes which catalog entry this connector is an instance of. For example, every Okta connector will have the same catalogId indicating it is an Okta connector.
     *
     * @generated from protobuf field: string catalog_id = 3
     */
    catalogId: string;
    /**
     * The userIds of the app owners.
     *
     * @generated from protobuf field: repeated string app_owners_ids = 4
     */
    appOwnersIds: string[];
    /**
     * The userIds of the connector owners. If let blank, the app owners will be used as the connector owners.
     *
     * @generated from protobuf field: repeated string connector_owners_ids = 5
     */
    connectorOwnersIds: string[];
    /**
     * For promoting from an unmanaged app
     *
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref = 6
     */
    appManagedStateBindingRef?: AppManagedStateBindingRef;
}
/**
 * The UpdateAppRequest message contains the app to update and the fields to update.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateAppRequest
 */
export interface UpdateAppRequest {
    /**
     * The app being updated in the request.
     *
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
    /**
     * The comma-sepparated list of fields to update in the view. "display_name,description"
     * would update display name and description regardless of what values are set on the request object.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppRequest
 */
export interface GetAppRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: bool include_deleted = 2
     */
    includeDeleted: boolean;
}
/**
 * The GetAppResponse message contains the details of the requested app in the app field.
 *
 * @generated from protobuf message c1.api.app.v1.GetAppResponse
 */
export interface GetAppResponse {
    /**
     * The app object returned by the request
     *
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
}
/**
 * Returns the new app's values.
 *
 * @generated from protobuf message c1.api.app.v1.CreateAppResponse
 */
export interface CreateAppResponse {
    /**
     * The created app
     *
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
}
/**
 * Returns the updated app's new values.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateAppResponse
 */
export interface UpdateAppResponse {
    /**
     * The updated app
     *
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
}
/**
 * Empty request body
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppRequest
 */
export interface DeleteAppRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppResponse
 */
export interface DeleteAppResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppsRequest
 */
export interface ListAppsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * The ListAppsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppsResponse
 */
export interface ListAppsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.App list = 1
     */
    list: App[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * Search Apps by a few properties.
 *
 * @generated from protobuf message c1.api.app.v1.SearchAppsRequest
 */
export interface SearchAppsRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name and description.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * A list of app IDs to remove from the results.
     *
     * @generated from protobuf field: repeated string exclude_app_ids = 4
     */
    excludeAppIds: string[];
    /**
     * A list of app IDs to restrict the search to.
     *
     * @generated from protobuf field: repeated string app_ids = 5
     */
    appIds: string[];
    /**
     * Search for apps with a case insensitive match on the display name.
     *
     * @generated from protobuf field: string display_name = 6
     */
    displayName: string;
    /**
     * Only return apps which are directories
     *
     * @generated from protobuf field: bool only_directories = 7
     */
    onlyDirectories: boolean;
    /**
     * Search for apps that use any of these policies.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyRef policy_refs = 8
     */
    policyRefs: PolicyRef[];
}
/**
 * The SearchAppsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.SearchAppsResponse
 */
export interface SearchAppsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.App list = 1
     */
    list: App[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppsExpandedRequest
 */
export interface SearchAppsExpandedRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppExpandMask expand_mask = 6
     */
    expandMask?: AppExpandMask;
    /**
     * @generated from protobuf field: repeated string exclude_ids = 7
     */
    excludeIds: string[];
    /**
     * @generated from protobuf field: repeated string ids = 8
     */
    ids: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppRef refs = 9
     */
    refs: AppRef[];
    /**
     * @generated from protobuf field: bool only_directories = 10
     */
    onlyDirectories: boolean;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppOwnersCount amount_of_app_owners = 11
     */
    amountOfAppOwners: AppOwnersCount;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserStatus user_statuses = 12
     */
    userStatuses: UserStatus[];
    /**
     * @generated from protobuf field: repeated string app_owner_ids = 13
     */
    appOwnerIds: string[];
    /**
     * @generated from protobuf field: bool only_v2_connectors = 14
     */
    onlyV2Connectors: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyRef policy_refs = 15
     */
    policyRefs: PolicyRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppsExpandedResponse
 */
export interface SearchAppsExpandedResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppView list = 1
     */
    list: AppView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 4
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.MultiGetAppResponse
 */
export interface MultiGetAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppView list = 1
     */
    list: AppView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.MultiGetAppRequest
 */
export interface MultiGetAppRequest {
    /**
     * @generated from protobuf field: repeated string app_ids = 1
     */
    appIds: string[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppExpandMask expand_mask = 2
     */
    expandMask?: AppExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetInactiveOwnersCountsRequest
 */
export interface GetInactiveOwnersCountsRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.GetInactiveOwnersCountsResponse
 */
export interface GetInactiveOwnersCountsResponse {
    /**
     * @generated from protobuf field: int64 apps_count = 1
     */
    appsCount: number;
    /**
     * @generated from protobuf field: int64 entitlements_count = 2
     */
    entitlementsCount: number;
    /**
     * @generated from protobuf field: int64 resources_count = 3
     */
    resourcesCount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppAndOwners
 */
export interface AppAndOwners {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppView app_view = 1
     */
    appView?: AppView;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User app_owners = 2
     */
    appOwners: User[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest
 */
export interface SearchAppsWithDeactivatedOwnerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppExpandMask expand_mask = 3
     */
    expandMask?: AppExpandMask;
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppsWithDeactivatedOwnerResponse
 */
export interface SearchAppsWithDeactivatedOwnerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppAndOwners list = 1
     */
    list: AppAndOwners[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppSearchFilter
 */
export interface AppSearchFilter {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string ids = 2
     */
    ids: string[];
    /**
     * @generated from protobuf field: repeated string exclude_ids = 3
     */
    excludeIds: string[];
    /**
     * @generated from protobuf field: bool only_directories = 4
     */
    onlyDirectories: boolean;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppUserIdentityMatching
 */
export enum AppUserIdentityMatching {
    /**
     * @generated from protobuf enum value: APP_USER_IDENTITY_MATCHING_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * This maps the app user to the identity by email or username.
     *
     * @generated from protobuf enum value: APP_USER_IDENTITY_MATCHING_STRICT = 1;
     */
    STRICT = 1,
    /**
     * This maps the user to the identity by display name if we don't find a matching username or email.
     *
     * @generated from protobuf enum value: APP_USER_IDENTITY_MATCHING_DISPLAY_NAME = 2;
     */
    DISPLAY_NAME = 2
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppOwnersCount
 */
export enum AppOwnersCount {
    /**
     * @generated from protobuf enum value: NOT_SPECIFIED = 0;
     */
    NOT_SPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ZERO_APP_OWNERS = 1;
     */
    ZERO_APP_OWNERS = 1,
    /**
     * @generated from protobuf enum value: ONE_APP_OWNER = 2;
     */
    ONE_APP_OWNER = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class SetAppIconRequest$Type extends MessageType<SetAppIconRequest> {
    constructor() {
        super("c1.api.app.v1.SetAppIconRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "4", maxLen: "1000000" } } } }
        ]);
    }
    create(value?: PartialMessage<SetAppIconRequest>): SetAppIconRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<SetAppIconRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppIconRequest): SetAppIconRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* bytes data */ 2:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppIconRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* bytes data = 2; */
        if (message.data.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppIconRequest
 */
export const SetAppIconRequest = new SetAppIconRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppIconResponse$Type extends MessageType<SetAppIconResponse> {
    constructor() {
        super("c1.api.app.v1.SetAppIconResponse", []);
    }
    create(value?: PartialMessage<SetAppIconResponse>): SetAppIconResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetAppIconResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppIconResponse): SetAppIconResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppIconResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppIconResponse
 */
export const SetAppIconResponse = new SetAppIconResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpliftAppUsersRequest$Type extends MessageType<UpliftAppUsersRequest> {
    constructor() {
        super("c1.api.app.v1.UpliftAppUsersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<UpliftAppUsersRequest>): UpliftAppUsersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<UpliftAppUsersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpliftAppUsersRequest): UpliftAppUsersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpliftAppUsersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpliftAppUsersRequest
 */
export const UpliftAppUsersRequest = new UpliftAppUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpliftAppUsersResponse$Type extends MessageType<UpliftAppUsersResponse> {
    constructor() {
        super("c1.api.app.v1.UpliftAppUsersResponse", []);
    }
    create(value?: PartialMessage<UpliftAppUsersResponse>): UpliftAppUsersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpliftAppUsersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpliftAppUsersResponse): UpliftAppUsersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpliftAppUsersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpliftAppUsersResponse
 */
export const UpliftAppUsersResponse = new UpliftAppUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppExpandMask$Type extends MessageType<AppExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "parent_app_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppExpandMask>): AppExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AppExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppExpandMask): AppExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppExpandMask
 */
export const AppExpandMask = new AppExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppView$Type extends MessageType<AppView> {
    constructor() {
        super("c1.api.app.v1.AppView", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "parent_app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppView>): AppView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.parentAppPath = "";
        if (value !== undefined)
            reflectionMergePartial<AppView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppView): AppView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* string parent_app_path */ 2:
                    message.parentAppPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string parent_app_path = 2; */
        if (message.parentAppPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.parentAppPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppView
 */
export const AppView = new AppView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppRef$Type extends MessageType<AppRef> {
    constructor() {
        super("c1.api.app.v1.AppRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppRef>): AppRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AppRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppRef): AppRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppRef
 */
export const AppRef = new AppRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class App$Type extends MessageType<App> {
    constructor() {
        super("c1.api.app.v1.App", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 7, name: "grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 8, name: "revoke_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 9, name: "logo_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "parent_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 11, name: "certify_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 12, name: "app_account_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "app_account_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 14, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "monthly_cost_usd", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "field_mask", kind: "message", T: () => FieldMask, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 17, name: "user_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 18, name: "is_directory", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 19, name: "app_owners", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 20, name: "identity_matching", kind: "enum", T: () => ["c1.api.app.v1.AppUserIdentityMatching", AppUserIdentityMatching, "APP_USER_IDENTITY_MATCHING_"] },
            { no: 22, name: "is_manually_managed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "strict_access_entitlement_provisioning", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "connector_version", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 25, name: "default_request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 27, name: "enable_connector_sourced_ownership", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App" } }] }, "policy.v1.msg": { enabled: true, name: "app", keyFields: ["id"] } });
    }
    create(value?: PartialMessage<App>): App {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.grantPolicyId = "";
        message.revokePolicyId = "";
        message.logoUri = "";
        message.parentAppId = "";
        message.certifyPolicyId = "";
        message.appAccountId = "";
        message.appAccountName = "";
        message.iconUrl = "";
        message.monthlyCostUsd = 0;
        message.userCount = 0;
        message.isDirectory = false;
        message.appOwners = [];
        message.identityMatching = 0;
        message.isManuallyManaged = false;
        message.strictAccessEntitlementProvisioning = false;
        message.connectorVersion = 0;
        message.defaultRequestCatalogId = "";
        message.instructions = "";
        message.enableConnectorSourcedOwnership = false;
        if (value !== undefined)
            reflectionMergePartial<App>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: App): App {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 4:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string display_name */ 5:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                case /* string grant_policy_id */ 7:
                    message.grantPolicyId = reader.string();
                    break;
                case /* string revoke_policy_id */ 8:
                    message.revokePolicyId = reader.string();
                    break;
                case /* string logo_uri */ 9:
                    message.logoUri = reader.string();
                    break;
                case /* string parent_app_id */ 10:
                    message.parentAppId = reader.string();
                    break;
                case /* string certify_policy_id */ 11:
                    message.certifyPolicyId = reader.string();
                    break;
                case /* string app_account_id */ 12:
                    message.appAccountId = reader.string();
                    break;
                case /* string app_account_name */ 13:
                    message.appAccountName = reader.string();
                    break;
                case /* string icon_url */ 14:
                    message.iconUrl = reader.string();
                    break;
                case /* int32 monthly_cost_usd */ 15:
                    message.monthlyCostUsd = reader.int32();
                    break;
                case /* google.protobuf.FieldMask field_mask */ 16:
                    message.fieldMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.fieldMask);
                    break;
                case /* int64 user_count */ 17:
                    message.userCount = reader.int64().toNumber();
                    break;
                case /* bool is_directory */ 18:
                    message.isDirectory = reader.bool();
                    break;
                case /* repeated c1.api.user.v1.User app_owners */ 19:
                    message.appOwners.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.app.v1.AppUserIdentityMatching identity_matching */ 20:
                    message.identityMatching = reader.int32();
                    break;
                case /* bool is_manually_managed */ 22:
                    message.isManuallyManaged = reader.bool();
                    break;
                case /* bool strict_access_entitlement_provisioning */ 23:
                    message.strictAccessEntitlementProvisioning = reader.bool();
                    break;
                case /* uint32 connector_version */ 24:
                    message.connectorVersion = reader.uint32();
                    break;
                case /* string default_request_catalog_id */ 25:
                    message.defaultRequestCatalogId = reader.string();
                    break;
                case /* string instructions */ 26:
                    message.instructions = reader.string();
                    break;
                case /* bool enable_connector_sourced_ownership */ 27:
                    message.enableConnectorSourcedOwnership = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: App, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 4; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 5; */
        if (message.displayName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.displayName);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* string grant_policy_id = 7; */
        if (message.grantPolicyId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.grantPolicyId);
        /* string revoke_policy_id = 8; */
        if (message.revokePolicyId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.revokePolicyId);
        /* string logo_uri = 9; */
        if (message.logoUri !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.logoUri);
        /* string parent_app_id = 10; */
        if (message.parentAppId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.parentAppId);
        /* string certify_policy_id = 11; */
        if (message.certifyPolicyId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.certifyPolicyId);
        /* string app_account_id = 12; */
        if (message.appAccountId !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.appAccountId);
        /* string app_account_name = 13; */
        if (message.appAccountName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.appAccountName);
        /* string icon_url = 14; */
        if (message.iconUrl !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.iconUrl);
        /* int32 monthly_cost_usd = 15; */
        if (message.monthlyCostUsd !== 0)
            writer.tag(15, WireType.Varint).int32(message.monthlyCostUsd);
        /* google.protobuf.FieldMask field_mask = 16; */
        if (message.fieldMask)
            FieldMask.internalBinaryWrite(message.fieldMask, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* int64 user_count = 17; */
        if (message.userCount !== 0)
            writer.tag(17, WireType.Varint).int64(message.userCount);
        /* bool is_directory = 18; */
        if (message.isDirectory !== false)
            writer.tag(18, WireType.Varint).bool(message.isDirectory);
        /* repeated c1.api.user.v1.User app_owners = 19; */
        for (let i = 0; i < message.appOwners.length; i++)
            User.internalBinaryWrite(message.appOwners[i], writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppUserIdentityMatching identity_matching = 20; */
        if (message.identityMatching !== 0)
            writer.tag(20, WireType.Varint).int32(message.identityMatching);
        /* bool is_manually_managed = 22; */
        if (message.isManuallyManaged !== false)
            writer.tag(22, WireType.Varint).bool(message.isManuallyManaged);
        /* bool strict_access_entitlement_provisioning = 23; */
        if (message.strictAccessEntitlementProvisioning !== false)
            writer.tag(23, WireType.Varint).bool(message.strictAccessEntitlementProvisioning);
        /* uint32 connector_version = 24; */
        if (message.connectorVersion !== 0)
            writer.tag(24, WireType.Varint).uint32(message.connectorVersion);
        /* string default_request_catalog_id = 25; */
        if (message.defaultRequestCatalogId !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.defaultRequestCatalogId);
        /* string instructions = 26; */
        if (message.instructions !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.instructions);
        /* bool enable_connector_sourced_ownership = 27; */
        if (message.enableConnectorSourcedOwnership !== false)
            writer.tag(27, WireType.Varint).bool(message.enableConnectorSourcedOwnership);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.App
 */
export const App = new App$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppRequest$Type extends MessageType<CreateAppRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAppRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 4, name: "owners", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 6, name: "revoke_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 7, name: "certify_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 8, name: "monthly_cost_usd", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "strict_access_entitlement_provisioning", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "identity_matching", kind: "enum", T: () => ["c1.api.app.v1.AppUserIdentityMatching", AppUserIdentityMatching, "APP_USER_IDENTITY_MATCHING_"] },
            { no: 11, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App" } }] } });
    }
    create(value?: PartialMessage<CreateAppRequest>): CreateAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        message.owners = [];
        message.grantPolicyId = "";
        message.revokePolicyId = "";
        message.certifyPolicyId = "";
        message.monthlyCostUsd = 0;
        message.strictAccessEntitlementProvisioning = false;
        message.identityMatching = 0;
        message.instructions = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAppRequest): CreateAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* repeated string owners */ 4:
                    message.owners.push(reader.string());
                    break;
                case /* string grant_policy_id */ 5:
                    message.grantPolicyId = reader.string();
                    break;
                case /* string revoke_policy_id */ 6:
                    message.revokePolicyId = reader.string();
                    break;
                case /* string certify_policy_id */ 7:
                    message.certifyPolicyId = reader.string();
                    break;
                case /* int32 monthly_cost_usd */ 8:
                    message.monthlyCostUsd = reader.int32();
                    break;
                case /* bool strict_access_entitlement_provisioning */ 9:
                    message.strictAccessEntitlementProvisioning = reader.bool();
                    break;
                case /* c1.api.app.v1.AppUserIdentityMatching identity_matching */ 10:
                    message.identityMatching = reader.int32();
                    break;
                case /* string instructions */ 11:
                    message.instructions = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* repeated string owners = 4; */
        for (let i = 0; i < message.owners.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.owners[i]);
        /* string grant_policy_id = 5; */
        if (message.grantPolicyId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.grantPolicyId);
        /* string revoke_policy_id = 6; */
        if (message.revokePolicyId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.revokePolicyId);
        /* string certify_policy_id = 7; */
        if (message.certifyPolicyId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.certifyPolicyId);
        /* int32 monthly_cost_usd = 8; */
        if (message.monthlyCostUsd !== 0)
            writer.tag(8, WireType.Varint).int32(message.monthlyCostUsd);
        /* bool strict_access_entitlement_provisioning = 9; */
        if (message.strictAccessEntitlementProvisioning !== false)
            writer.tag(9, WireType.Varint).bool(message.strictAccessEntitlementProvisioning);
        /* c1.api.app.v1.AppUserIdentityMatching identity_matching = 10; */
        if (message.identityMatching !== 0)
            writer.tag(10, WireType.Varint).int32(message.identityMatching);
        /* string instructions = 11; */
        if (message.instructions !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.instructions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppRequest
 */
export const CreateAppRequest = new CreateAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppWithConnectorRequest$Type extends MessageType<CreateAppWithConnectorRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAppWithConnectorRequest", [
            { no: 1, name: "app_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "app_owners_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "connector_owners_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<CreateAppWithConnectorRequest>): CreateAppWithConnectorRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appDisplayName = "";
        message.appDescription = "";
        message.catalogId = "";
        message.appOwnersIds = [];
        message.connectorOwnersIds = [];
        if (value !== undefined)
            reflectionMergePartial<CreateAppWithConnectorRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAppWithConnectorRequest): CreateAppWithConnectorRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_display_name */ 1:
                    message.appDisplayName = reader.string();
                    break;
                case /* string app_description */ 2:
                    message.appDescription = reader.string();
                    break;
                case /* string catalog_id */ 3:
                    message.catalogId = reader.string();
                    break;
                case /* repeated string app_owners_ids */ 4:
                    message.appOwnersIds.push(reader.string());
                    break;
                case /* repeated string connector_owners_ids */ 5:
                    message.connectorOwnersIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAppWithConnectorRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_display_name = 1; */
        if (message.appDisplayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appDisplayName);
        /* string app_description = 2; */
        if (message.appDescription !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appDescription);
        /* string catalog_id = 3; */
        if (message.catalogId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.catalogId);
        /* repeated string app_owners_ids = 4; */
        for (let i = 0; i < message.appOwnersIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.appOwnersIds[i]);
        /* repeated string connector_owners_ids = 5; */
        for (let i = 0; i < message.connectorOwnersIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.connectorOwnersIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppWithConnectorRequest
 */
export const CreateAppWithConnectorRequest = new CreateAppWithConnectorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppWithUnmanagedRequest$Type extends MessageType<CreateAppWithUnmanagedRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAppWithUnmanagedRequest", [
            { no: 1, name: "app_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "app_owners_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "connector_owners_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "app_managed_state_binding_ref", kind: "message", T: () => AppManagedStateBindingRef }
        ]);
    }
    create(value?: PartialMessage<CreateAppWithUnmanagedRequest>): CreateAppWithUnmanagedRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appDisplayName = "";
        message.appDescription = "";
        message.catalogId = "";
        message.appOwnersIds = [];
        message.connectorOwnersIds = [];
        if (value !== undefined)
            reflectionMergePartial<CreateAppWithUnmanagedRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAppWithUnmanagedRequest): CreateAppWithUnmanagedRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_display_name */ 1:
                    message.appDisplayName = reader.string();
                    break;
                case /* string app_description */ 2:
                    message.appDescription = reader.string();
                    break;
                case /* string catalog_id */ 3:
                    message.catalogId = reader.string();
                    break;
                case /* repeated string app_owners_ids */ 4:
                    message.appOwnersIds.push(reader.string());
                    break;
                case /* repeated string connector_owners_ids */ 5:
                    message.connectorOwnersIds.push(reader.string());
                    break;
                case /* c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref */ 6:
                    message.appManagedStateBindingRef = AppManagedStateBindingRef.internalBinaryRead(reader, reader.uint32(), options, message.appManagedStateBindingRef);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAppWithUnmanagedRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_display_name = 1; */
        if (message.appDisplayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appDisplayName);
        /* string app_description = 2; */
        if (message.appDescription !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appDescription);
        /* string catalog_id = 3; */
        if (message.catalogId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.catalogId);
        /* repeated string app_owners_ids = 4; */
        for (let i = 0; i < message.appOwnersIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.appOwnersIds[i]);
        /* repeated string connector_owners_ids = 5; */
        for (let i = 0; i < message.connectorOwnersIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.connectorOwnersIds[i]);
        /* c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref = 6; */
        if (message.appManagedStateBindingRef)
            AppManagedStateBindingRef.internalBinaryWrite(message.appManagedStateBindingRef, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppWithUnmanagedRequest
 */
export const CreateAppWithUnmanagedRequest = new CreateAppWithUnmanagedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppRequest$Type extends MessageType<UpdateAppRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateAppRequest", [
            { no: 1, name: "app", kind: "message", T: () => App, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<UpdateAppRequest>): UpdateAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAppRequest): UpdateAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppRequest
 */
export const UpdateAppRequest = new UpdateAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppRequest$Type extends MessageType<GetAppRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetAppRequest>): GetAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.includeDeleted = false;
        if (value !== undefined)
            reflectionMergePartial<GetAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppRequest): GetAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool include_deleted */ 2:
                    message.includeDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool include_deleted = 2; */
        if (message.includeDeleted !== false)
            writer.tag(2, WireType.Varint).bool(message.includeDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppRequest
 */
export const GetAppRequest = new GetAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppResponse$Type extends MessageType<GetAppResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppResponse", [
            { no: 1, name: "app", kind: "message", T: () => App }
        ]);
    }
    create(value?: PartialMessage<GetAppResponse>): GetAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppResponse): GetAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppResponse
 */
export const GetAppResponse = new GetAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppResponse$Type extends MessageType<CreateAppResponse> {
    constructor() {
        super("c1.api.app.v1.CreateAppResponse", [
            { no: 1, name: "app", kind: "message", T: () => App }
        ]);
    }
    create(value?: PartialMessage<CreateAppResponse>): CreateAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAppResponse): CreateAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppResponse
 */
export const CreateAppResponse = new CreateAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppResponse$Type extends MessageType<UpdateAppResponse> {
    constructor() {
        super("c1.api.app.v1.UpdateAppResponse", [
            { no: 1, name: "app", kind: "message", T: () => App, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<UpdateAppResponse>): UpdateAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAppResponse): UpdateAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppResponse
 */
export const UpdateAppResponse = new UpdateAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppRequest$Type extends MessageType<DeleteAppRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App" } }] } });
    }
    create(value?: PartialMessage<DeleteAppRequest>): DeleteAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppRequest): DeleteAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppRequest
 */
export const DeleteAppRequest = new DeleteAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppResponse$Type extends MessageType<DeleteAppResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppResponse", []);
    }
    create(value?: PartialMessage<DeleteAppResponse>): DeleteAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppResponse): DeleteAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppResponse
 */
export const DeleteAppResponse = new DeleteAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppsRequest$Type extends MessageType<ListAppsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAppsRequest>): ListAppsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppsRequest): ListAppsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppsRequest
 */
export const ListAppsRequest = new ListAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppsResponse$Type extends MessageType<ListAppsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppsResponse>): ListAppsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppsResponse): ListAppsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.App list */ 1:
                    message.list.push(App.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.App list = 1; */
        for (let i = 0; i < message.list.length; i++)
            App.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppsResponse
 */
export const ListAppsResponse = new ListAppsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsRequest$Type extends MessageType<SearchAppsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "only_directories", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "policy_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppsRequest>): SearchAppsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.excludeAppIds = [];
        message.appIds = [];
        message.displayName = "";
        message.onlyDirectories = false;
        message.policyRefs = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppsRequest): SearchAppsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string exclude_app_ids */ 4:
                    message.excludeAppIds.push(reader.string());
                    break;
                case /* repeated string app_ids */ 5:
                    message.appIds.push(reader.string());
                    break;
                case /* string display_name */ 6:
                    message.displayName = reader.string();
                    break;
                case /* bool only_directories */ 7:
                    message.onlyDirectories = reader.bool();
                    break;
                case /* repeated c1.api.policy.v1.PolicyRef policy_refs */ 8:
                    message.policyRefs.push(PolicyRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string exclude_app_ids = 4; */
        for (let i = 0; i < message.excludeAppIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.excludeAppIds[i]);
        /* repeated string app_ids = 5; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appIds[i]);
        /* string display_name = 6; */
        if (message.displayName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.displayName);
        /* bool only_directories = 7; */
        if (message.onlyDirectories !== false)
            writer.tag(7, WireType.Varint).bool(message.onlyDirectories);
        /* repeated c1.api.policy.v1.PolicyRef policy_refs = 8; */
        for (let i = 0; i < message.policyRefs.length; i++)
            PolicyRef.internalBinaryWrite(message.policyRefs[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsRequest
 */
export const SearchAppsRequest = new SearchAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsResponse$Type extends MessageType<SearchAppsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppsResponse>): SearchAppsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppsResponse): SearchAppsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.App list */ 1:
                    message.list.push(App.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.App list = 1; */
        for (let i = 0; i < message.list.length; i++)
            App.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsResponse
 */
export const SearchAppsResponse = new SearchAppsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsExpandedRequest$Type extends MessageType<SearchAppsExpandedRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppsExpandedRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppExpandMask },
            { no: 7, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 10, name: "only_directories", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "amount_of_app_owners", kind: "enum", T: () => ["c1.api.app.v1.AppOwnersCount", AppOwnersCount], options: { "validate.rules": { enum: { definedOnly: true } } } },
            { no: 12, name: "user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserStatus", UserStatus] },
            { no: 13, name: "app_owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 14, name: "only_v2_connectors", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "policy_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppsExpandedRequest>): SearchAppsExpandedRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.excludeIds = [];
        message.ids = [];
        message.refs = [];
        message.onlyDirectories = false;
        message.amountOfAppOwners = 0;
        message.userStatuses = [];
        message.appOwnerIds = [];
        message.onlyV2Connectors = false;
        message.policyRefs = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppsExpandedRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppsExpandedRequest): SearchAppsExpandedRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* c1.api.app.v1.AppExpandMask expand_mask */ 6:
                    message.expandMask = AppExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string exclude_ids */ 7:
                    message.excludeIds.push(reader.string());
                    break;
                case /* repeated string ids */ 8:
                    message.ids.push(reader.string());
                    break;
                case /* repeated c1.api.app.v1.AppRef refs */ 9:
                    message.refs.push(AppRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool only_directories */ 10:
                    message.onlyDirectories = reader.bool();
                    break;
                case /* c1.api.app.v1.AppOwnersCount amount_of_app_owners */ 11:
                    message.amountOfAppOwners = reader.int32();
                    break;
                case /* repeated c1.api.user.v1.UserStatus user_statuses */ 12:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.userStatuses.push(reader.int32());
                    else
                        message.userStatuses.push(reader.int32());
                    break;
                case /* repeated string app_owner_ids */ 13:
                    message.appOwnerIds.push(reader.string());
                    break;
                case /* bool only_v2_connectors */ 14:
                    message.onlyV2Connectors = reader.bool();
                    break;
                case /* repeated c1.api.policy.v1.PolicyRef policy_refs */ 15:
                    message.policyRefs.push(PolicyRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppsExpandedRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* c1.api.app.v1.AppExpandMask expand_mask = 6; */
        if (message.expandMask)
            AppExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string exclude_ids = 7; */
        for (let i = 0; i < message.excludeIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.excludeIds[i]);
        /* repeated string ids = 8; */
        for (let i = 0; i < message.ids.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.ids[i]);
        /* repeated c1.api.app.v1.AppRef refs = 9; */
        for (let i = 0; i < message.refs.length; i++)
            AppRef.internalBinaryWrite(message.refs[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool only_directories = 10; */
        if (message.onlyDirectories !== false)
            writer.tag(10, WireType.Varint).bool(message.onlyDirectories);
        /* c1.api.app.v1.AppOwnersCount amount_of_app_owners = 11; */
        if (message.amountOfAppOwners !== 0)
            writer.tag(11, WireType.Varint).int32(message.amountOfAppOwners);
        /* repeated c1.api.user.v1.UserStatus user_statuses = 12; */
        if (message.userStatuses.length) {
            writer.tag(12, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.userStatuses.length; i++)
                writer.int32(message.userStatuses[i]);
            writer.join();
        }
        /* repeated string app_owner_ids = 13; */
        for (let i = 0; i < message.appOwnerIds.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.appOwnerIds[i]);
        /* bool only_v2_connectors = 14; */
        if (message.onlyV2Connectors !== false)
            writer.tag(14, WireType.Varint).bool(message.onlyV2Connectors);
        /* repeated c1.api.policy.v1.PolicyRef policy_refs = 15; */
        for (let i = 0; i < message.policyRefs.length; i++)
            PolicyRef.internalBinaryWrite(message.policyRefs[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsExpandedRequest
 */
export const SearchAppsExpandedRequest = new SearchAppsExpandedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsExpandedResponse$Type extends MessageType<SearchAppsExpandedResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppsExpandedResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchAppsExpandedResponse>): SearchAppsExpandedResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppsExpandedResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppsExpandedResponse): SearchAppsExpandedResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppView list */ 1:
                    message.list.push(AppView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 4:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppsExpandedResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 4; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsExpandedResponse
 */
export const SearchAppsExpandedResponse = new SearchAppsExpandedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MultiGetAppResponse$Type extends MessageType<MultiGetAppResponse> {
    constructor() {
        super("c1.api.app.v1.MultiGetAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppView },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<MultiGetAppResponse>): MultiGetAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<MultiGetAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MultiGetAppResponse): MultiGetAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppView list */ 1:
                    message.list.push(AppView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MultiGetAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.MultiGetAppResponse
 */
export const MultiGetAppResponse = new MultiGetAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MultiGetAppRequest$Type extends MessageType<MultiGetAppRequest> {
    constructor() {
        super("c1.api.app.v1.MultiGetAppRequest", [
            { no: 1, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => AppExpandMask }
        ]);
    }
    create(value?: PartialMessage<MultiGetAppRequest>): MultiGetAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appIds = [];
        if (value !== undefined)
            reflectionMergePartial<MultiGetAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MultiGetAppRequest): MultiGetAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string app_ids */ 1:
                    message.appIds.push(reader.string());
                    break;
                case /* c1.api.app.v1.AppExpandMask expand_mask */ 2:
                    message.expandMask = AppExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MultiGetAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string app_ids = 1; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.appIds[i]);
        /* c1.api.app.v1.AppExpandMask expand_mask = 2; */
        if (message.expandMask)
            AppExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.MultiGetAppRequest
 */
export const MultiGetAppRequest = new MultiGetAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInactiveOwnersCountsRequest$Type extends MessageType<GetInactiveOwnersCountsRequest> {
    constructor() {
        super("c1.api.app.v1.GetInactiveOwnersCountsRequest", []);
    }
    create(value?: PartialMessage<GetInactiveOwnersCountsRequest>): GetInactiveOwnersCountsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInactiveOwnersCountsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInactiveOwnersCountsRequest): GetInactiveOwnersCountsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInactiveOwnersCountsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetInactiveOwnersCountsRequest
 */
export const GetInactiveOwnersCountsRequest = new GetInactiveOwnersCountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInactiveOwnersCountsResponse$Type extends MessageType<GetInactiveOwnersCountsResponse> {
    constructor() {
        super("c1.api.app.v1.GetInactiveOwnersCountsResponse", [
            { no: 1, name: "apps_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "entitlements_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "resources_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<GetInactiveOwnersCountsResponse>): GetInactiveOwnersCountsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appsCount = 0;
        message.entitlementsCount = 0;
        message.resourcesCount = 0;
        if (value !== undefined)
            reflectionMergePartial<GetInactiveOwnersCountsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInactiveOwnersCountsResponse): GetInactiveOwnersCountsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 apps_count */ 1:
                    message.appsCount = reader.int64().toNumber();
                    break;
                case /* int64 entitlements_count */ 2:
                    message.entitlementsCount = reader.int64().toNumber();
                    break;
                case /* int64 resources_count */ 3:
                    message.resourcesCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInactiveOwnersCountsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 apps_count = 1; */
        if (message.appsCount !== 0)
            writer.tag(1, WireType.Varint).int64(message.appsCount);
        /* int64 entitlements_count = 2; */
        if (message.entitlementsCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.entitlementsCount);
        /* int64 resources_count = 3; */
        if (message.resourcesCount !== 0)
            writer.tag(3, WireType.Varint).int64(message.resourcesCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetInactiveOwnersCountsResponse
 */
export const GetInactiveOwnersCountsResponse = new GetInactiveOwnersCountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppAndOwners$Type extends MessageType<AppAndOwners> {
    constructor() {
        super("c1.api.app.v1.AppAndOwners", [
            { no: 1, name: "app_view", kind: "message", T: () => AppView },
            { no: 2, name: "app_owners", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
    create(value?: PartialMessage<AppAndOwners>): AppAndOwners {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appOwners = [];
        if (value !== undefined)
            reflectionMergePartial<AppAndOwners>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppAndOwners): AppAndOwners {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppView app_view */ 1:
                    message.appView = AppView.internalBinaryRead(reader, reader.uint32(), options, message.appView);
                    break;
                case /* repeated c1.api.user.v1.User app_owners */ 2:
                    message.appOwners.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppAndOwners, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppView app_view = 1; */
        if (message.appView)
            AppView.internalBinaryWrite(message.appView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.User app_owners = 2; */
        for (let i = 0; i < message.appOwners.length; i++)
            User.internalBinaryWrite(message.appOwners[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAndOwners
 */
export const AppAndOwners = new AppAndOwners$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsWithDeactivatedOwnerRequest$Type extends MessageType<SearchAppsWithDeactivatedOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppExpandMask },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppsWithDeactivatedOwnerRequest>): SearchAppsWithDeactivatedOwnerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppsWithDeactivatedOwnerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppsWithDeactivatedOwnerRequest): SearchAppsWithDeactivatedOwnerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppExpandMask expand_mask */ 3:
                    message.expandMask = AppExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppsWithDeactivatedOwnerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest
 */
export const SearchAppsWithDeactivatedOwnerRequest = new SearchAppsWithDeactivatedOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsWithDeactivatedOwnerResponse$Type extends MessageType<SearchAppsWithDeactivatedOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppsWithDeactivatedOwnerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppAndOwners },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppsWithDeactivatedOwnerResponse>): SearchAppsWithDeactivatedOwnerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppsWithDeactivatedOwnerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppsWithDeactivatedOwnerResponse): SearchAppsWithDeactivatedOwnerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppAndOwners list */ 1:
                    message.list.push(AppAndOwners.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppsWithDeactivatedOwnerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppAndOwners list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppAndOwners.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsWithDeactivatedOwnerResponse
 */
export const SearchAppsWithDeactivatedOwnerResponse = new SearchAppsWithDeactivatedOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppSearchFilter$Type extends MessageType<AppSearchFilter> {
    constructor() {
        super("c1.api.app.v1.AppSearchFilter", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "only_directories", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AppSearchFilter>): AppSearchFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.ids = [];
        message.excludeIds = [];
        message.onlyDirectories = false;
        if (value !== undefined)
            reflectionMergePartial<AppSearchFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppSearchFilter): AppSearchFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated string ids */ 2:
                    message.ids.push(reader.string());
                    break;
                case /* repeated string exclude_ids */ 3:
                    message.excludeIds.push(reader.string());
                    break;
                case /* bool only_directories */ 4:
                    message.onlyDirectories = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppSearchFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated string ids = 2; */
        for (let i = 0; i < message.ids.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.ids[i]);
        /* repeated string exclude_ids = 3; */
        for (let i = 0; i < message.excludeIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.excludeIds[i]);
        /* bool only_directories = 4; */
        if (message.onlyDirectories !== false)
            writer.tag(4, WireType.Varint).bool(message.onlyDirectories);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppSearchFilter
 */
export const AppSearchFilter = new AppSearchFilter$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.Apps
 */
export const Apps = new ServiceType("c1.api.app.v1.Apps", [
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "App" }] }, "authz.method": { role: "VIEWER" } }, I: GetAppRequest, O: GetAppResponse },
    { name: "MultiGet", options: { "authz.method": { role: "VIEWER" } }, I: MultiGetAppRequest, O: MultiGetAppResponse },
    { name: "List", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps", query: { page_size: "page_size", page_token: "page_token" }, group: "App" }] }, "authz.method": { role: "VIEWER" } }, I: ListAppsRequest, O: ListAppsResponse },
    { name: "Create", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App" }], group: "App" }] }, "authz.method": { role: "EDITOR" } }, I: CreateAppRequest, O: CreateAppResponse },
    { name: "CreateWithConnector", options: { "authz.method": { role: "OWNER" } }, I: CreateAppWithConnectorRequest, O: CreateAppResponse },
    { name: "CreateWithUnmanagedApp", options: { "authz.method": { role: "OWNER" } }, I: CreateAppWithUnmanagedRequest, O: CreateAppResponse },
    { name: "Update", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "App" }], group: "App" }] }, "authz.method": { role: "EDITOR" } }, I: UpdateAppRequest, O: UpdateAppResponse },
    { name: "Delete", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App" }], group: "App" }] }, "authz.method": { role: "EDITOR" } }, I: DeleteAppRequest, O: DeleteAppResponse },
    { name: "SetAppIcon", options: { "authz.method": { role: "OWNER" } }, I: SetAppIconRequest, O: SetAppIconResponse },
    { name: "UpliftAppUsers", options: { "authz.method": { role: "OWNER" } }, I: UpliftAppUsersRequest, O: UpliftAppUsersResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppSearch
 */
export const AppSearch = new ServiceType("c1.api.app.v1.AppSearch", [
    { name: "Search", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/apps", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Apps", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", in: "TERRAFORM_ENTITY_PAGINATION_INPUT_IN_REQUEST_BODY", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] }, "authz.method": { role: "VIEWER" } }, I: SearchAppsRequest, O: SearchAppsResponse },
    { name: "SearchAppsExpanded", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppsExpandedRequest, O: SearchAppsExpandedResponse },
    { name: "GetInactiveOwnersCounts", options: { "authz.method": { role: "VIEWER" } }, I: GetInactiveOwnersCountsRequest, O: GetInactiveOwnersCountsResponse },
    { name: "SearchAppsWithDeactivatedOwner", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppsWithDeactivatedOwnerRequest, O: SearchAppsWithDeactivatedOwnerResponse }
]);
